import axios from "axios";
import Cookies from "js-cookie";

// ✅ Main API instance
const api = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL || "https://devng.vandapardakht.ir",
});

// ✅ Payment API instance
const paymentApi = axios.create({
  baseURL: import.meta.env.VITE_PAYMENT_DATABASE_ENDPOINT || "https://pay-dev.vandapardakht.ir", // fallback if env is missing
});

// 🔐 Attach interceptors to both instances
const attachInterceptors = (instance) => {
  instance.interceptors.request.use(
    (config) => {
      const token = Cookies.get("token");
      if (token) {
        config.headers["token"] = token;
        config.headers["token_type"] = "bearer";
      }
      return config;
    },
    (error) => Promise.reject(error),
  );

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        Cookies.remove("token");
        window.location.href = "/";
      }
      return Promise.reject(error);
    },
  );
};

// Apply interceptors
attachInterceptors(api);
attachInterceptors(paymentApi);

export { api, paymentApi };
